
import {defineComponent} from 'vue'
import {TmsGaDto} from "../../ob1/dto/TmsGaDto";

export default defineComponent({
    name: "FeedbackModalDialog",
    props: {
        // id de la modal
        id: {
            type: String,
            required: true
        },
        modalTitle: {
            type: String,
            required: true,
        },
        modalContent: {
            type: String,
            required: true,
        },
        tmsCategory: {
            type: String,
            required: false,
            default: ""
        },
        tmsLabel: {
            type: String,
            required: false,
            default: "ouverture-popin"
        }
    },
    computed: {
        labelId() {
            return this.id + '-label'
        },
        actionTms(): TmsGaDto {
            return {
                category: this.tmsCategory,
                action: toBroadbandTmsFormat(this.actionLabel),
                label: toBroadbandTmsFormat(this.tmsLabel)
            }
        }
    },
    methods: {
        open(): void {
            const modalButtonOpener = (document.querySelector('[data-bs-toggle="modal"]') as HTMLElement);
            if (modalButtonOpener) modalButtonOpener.click();
        },
        close(): void {
            const modalButtonCloser = (document.querySelector('[data-bs-dismiss="modal"]') as HTMLElement);
            if (modalButtonCloser) modalButtonCloser.click();
        }
    }
})
